import { useTranslation } from 'react-i18next';
import { cn } from '../../../utils/cn';
import { Label as HeadlessLabel } from '@headlessui/react';

export default function Label({
  content,
  children,
  className,
  error,
  disabled,
}) {
  const { t } = useTranslation();

  return (
    <HeadlessLabel
      className={cn(
        'text-foreground text-lg font-semibold leading-7',
        disabled && 'text-foreground-disabled',
        error && 'text-error',
        className
      )}
    >
      {content ? t(content) : children}
    </HeadlessLabel>
  );
}
